import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_40gau4dz8q: FaireBrandEntity = {
  token: "b_40gau4dz8q",
  type: "brand",
  name: "Davi & Dani",
  avatarUrl:
    "https://cdn.faire.com/fastly/100a1cdb0960b53b30ce231962e7b4453ff78f08ec95198d9f64ead40e79c27c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7d03436e95156b3c8c9e82307fd625416f8b37d91d87ac8b77ff81657dfcf98e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/100a1cdb0960b53b30ce231962e7b4453ff78f08ec95198d9f64ead40e79c27c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7d03436e95156b3c8c9e82307fd625416f8b37d91d87ac8b77ff81657dfcf98e.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.7,
  reviewCount: 1395,
  isTopShop: true,
  isInsider: true,
  description:
    "Davi&Dani offers a blend of casual chic and sophisticated elegance, providing ready-to-wear styles for everyday life and special occasions. Our specialty includes tops, dresses, outerwear, and bottoms for the Young Contemporary market, but our creativity knows no bounds. Discover innovative and stylish fashion with Davi&Dani.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:21.920Z",
    importedBy: "entity-db-cli",
  },
};
